import { PERMISSIONS } from './permissions'
import { ROUTES } from './routesConstants'

export type MenuType = {
  label: string
  path?: string[]
  key: string
  icon?: string
  children?: MenuType[]
  permissions: string[]
}

export const menuData: MenuType[] = [
  {
    label: 'Trang chủ',
    path: [ROUTES.TRANG_CHU],
    key: 'home',
    icon: 'home',
    permissions: [PERMISSIONS.TRANGCHU]
  },
  {
    label: 'QLKLKN Thanh Tra',
    key: 'ket-luan-thanh-tra',
    permissions: [PERMISSIONS.QLKLKNTHANHTRA],
    icon: 'documentary',
    children: [
      {
        label: 'DS kết luận thanh tra',
        path: [ROUTES.DANH_SACH_KET_LUAN_THANH_TRA],
        key: 'danh-sach-ket-luan-thanh-tra',
        permissions: [PERMISSIONS.QLKLKNTHANHTRA_DANHSACH]
      },
      {
        label: 'Kiến nghị cần thực hiện',
        path: [ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI],
        key: 'danh-sach-thuc-hien-kien-nghi',
        permissions: [PERMISSIONS.THUCHIENKIENNGHI_THANHTRA_XEM]
      },
      {
        label: 'Theo dõi thực hiện kiến nghị',
        path: [ROUTES.THEO_DOI_KIEN_NGHI_THANH_TRA],
        key: 'ql-theo-doi-kien-nghi',
        permissions: [PERMISSIONS.THEODOIKIENNGHI_THANHTRA]
      }
    ]
  },
  {
    label: 'QLKLKN của Kiểm toán nhà nước',
    key: 'qlklkn-kiem-toan-nn',
    permissions: [PERMISSIONS.QLKLKNKIEMTOAN],
    icon: 'money',
    children: [
      {
        label: 'DS kết luận Kiểm toán',
        path: [ROUTES.DANH_SACH_KET_LUAN_KTNN],
        key: 'danh-sach-KTNN',
        permissions: [PERMISSIONS.QLKLKNKIEMTOAN_DANHSACH]
      },
      {
        label: 'Kiến nghị cần thực hiện',
        path: [ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI_KIEM_TOAN],
        key: 'danh-sach-thuc-hien-nghi-kiem-toan',
        permissions: [PERMISSIONS.THUCHIENKIENNGHI_KIEMTOAN_XEM]
      },
      {
        label: 'Theo dõi thực hiện kiến nghị',
        path: [ROUTES.THEO_DOI_KIEN_NGHI_KTNN],
        key: 'ql-theo-doi-kien-nghi-ktnn',
        permissions: [PERMISSIONS.THEODOIKIENNGHI_KIEMTOAN]
      }
    ]
  },
  {
    label: 'QL theo dõi thực hiện kết luận',
    key: 'ql-theo-doi-thuc-hien-ket-luan',
    permissions: [PERMISSIONS.THEODOIKETLUAN_XEMTATCA],
    icon: 'file-search',
    children: [
      {
        label: 'QL theo dõi kết luận thanh tra',
        path: [ROUTES.QL_DANH_SACH_KET_LUAN_THANH_TRA],
        key: 'QL-theo-doi-kltt',
        permissions: [PERMISSIONS.KETLUANTHANHTRA_XEMTATCA]
      },
      {
        label: 'QL theo dõi kiến nghị thanh tra',
        path: [ROUTES.QL_DANH_SACH_KIEN_NGHI_THANH_TRA],
        key: 'QL-theo-doi-kntt',
        permissions: [PERMISSIONS.THEODOIKIENNGHI_THANHTRA]
      },
      {
        label: 'QL theo dõi kết luận Kiểm toán',
        path: [ROUTES.QL_DANH_SACH_KET_LUAN_KTNN],
        key: 'QL-theo-doi-ktnn',
        permissions: [PERMISSIONS.KETLUANKIEMTOAN_XEMTATCA]
      },
      {
        label: 'QL theo dõi kiến nghị Kiểm toán',
        path: [ROUTES.QL_DANH_SACH_KIEN_NGHI_KIEM_TOAN],
        key: 'QL-theo-doi-knkt',
        permissions: [PERMISSIONS.THEODOIKIENNGHI_KIEMTOAN]
      }
    ]
  },
  {
    label: 'Báo cáo thống kê',
    key: 'bao-cao-thong-ke',
    permissions: [PERMISSIONS.BAOCAOTHONGKE],
    icon: 'statistical',
    children: [
      {
        label: 'BC kết quả xử lý cán bộ, công chức, viên chức theo kết luận thanh tra và kiến nghị Kiểm toán Nhà nước',
        path: [ROUTES.BAO_CAO_KET_QUA_XU_LY_CAN_BO_THEO_KLTT_VA_KIEN_NGHI_KTNN],
        key: 'bao-cao-ket-qua-xu-ly-can-bo-theo-kltt-va-kien-nghi-ktnn',
        permissions: [PERMISSIONS.BAOCAOTHONGKE]
      },
      {
        label: 'BC các kiến nghị đã hoàn thành theo các kết luận thanh tra, kiến nghị của Kiểm toán Nhà nước',
        path: [ROUTES.BAO_CAO_CAC_KIEN_NGHI_DA_HOAN_THANH_THEO_CAC_KLTT_KIEN_NGHI_CUA_KTNN],
        key: 'bao-cao-cac-kien-nghi-da-hoan-thanh-theo-cac-kltt-kien-nghi-cua-ktnn',
        permissions: [PERMISSIONS.BAOCAOTHONGKE]
      },
      {
        label: 'BC các kiến nghị chưa hoàn thành xong theo các kết luận thanh tra, kiến nghị Kiểm toán Nhà nước',
        path: [ROUTES.BAO_CAO_CAC_KIEN_NGHI_CHUA_HOAN_THANH_XONG_THEO_CAC_KLTT_KIEN_NGHI_CUA_KTNN],
        key: 'bao-cao-cac-kien-nghi-chua-hoan-thanh-xong-theo-cac-kltt-kien-nghi-kttn',
        permissions: [PERMISSIONS.BAOCAOTHONGKE]
      },
      {
        label: 'BC tổng hợp kết quả thực hiện các kết luận thanh tra theo đơn vị',
        path: [ROUTES.BAO_CAO_TONG_HOP_KET_LUAN_THANH_TRA],
        key: 'bao-cao-tong-hop-ket-luan-thanh-tra',
        permissions: [PERMISSIONS.BAOCAOTHONGKE]
      },
      {
        label: 'Tổng hợp kết quả thanh tra hành chính (01/TTr)',
        path: [ROUTES.TONG_HOP_KET_QUA_THANH_TRA_HANH_CHINH],
        key: 'tong-hop-ket-qua-thanh-tra-hanh-chinh',
        permissions: [PERMISSIONS.BAOCAOTHONGKE]
      },
      {
        label: 'Tổng hợp kết quả thực hiện kết luận thanh tra hành chính (02/TTr)',
        path: [ROUTES.BAO_CAO_TONG_HOP_THUC_HIEN_KET_LUAN_THANH_TRA_HANH_CHINH_02],
        key: 'bao-cao-tong-hop-thuc-hien-ket-luan-thanh-tra-hanh-chinh-02',
        permissions: [PERMISSIONS.BAOCAOTHONGKE]
      },
      {
        label: 'Tổng hợp kết quả thanh tra hành chính trong lĩnh vực đầu tư xây dựng cơ bản (03/TTr)',
        path: [ROUTES.TONG_HOP_KET_QUA_THANH_TRA_HANH_CHINH_TRONG_LINH_VUC_XDCB],
        key: 'tong-hop-ket-qua-thanh-tra-hanh-chinh-trong-linh-vuc-dau-tu-xdcb',
        permissions: [PERMISSIONS.BAOCAOTHONGKE]
      },
      {
        label: 'Tổng hợp kết quả thanh tra hành chính trong lĩnh vực Tài chính - Ngân sách (04/TTr)',
        path: [ROUTES.BAO_CAO_TONG_HOP_KET_QUA_HANH_CHINH_TRONG_LINH_VUC_TCNS],
        key: 'bao-cao-tong-hop-ket-qua-hanh-chinh-trong-linh-vuc-tcns',
        permissions: [PERMISSIONS.BAOCAOTHONGKE]
      },
      {
        label: 'Tổng hợp kết quả thanh tra hành chính trong lĩnh vực đất đai (05/TTr)',
        path: [ROUTES.TONG_HOP_KET_QUA_THANH_TRA_HANH_CHINH_TRONG_LINH_VUC_DAT_DAI],
        key: 'tong-hop-ket-qua-thanh-tra-hanh-chinh-trong-linh-vuc-dat-dai',
        permissions: [PERMISSIONS.BAOCAOTHONGKE]
      },
      {
        label: 'Tổng hợp kết quả thanh tra, kiểm tra chuyên ngành (06/TTr)',
        path: [ROUTES.TONG_HOP_KET_QUA_THANH_TRA_KIEM_TRA_CHUYEN_NGANH],
        key: 'tong-hop-ket-qua-thanh-tra-kiem-tra-chuyen-nganh',
        permissions: [PERMISSIONS.BAOCAOTHONGKE]
      },
      {
        label: 'Tổng hợp kết quả thực hiện kết luận, quyết định xử phạt qua thanh tra chuyên ngành (07/TTr)',
        path: [ROUTES.BAO_CAO_TONG_HOP_THUC_HIEN_KET_LUAN_QUYET_DINH_XU_PHAT_QUA_THANH_TRA_CHUYEN_NGANH],
        key: 'bao-cao-tong-hop-thuc-hien-ket-quyet-dinh-xu-phat-qua-thanh-tra-chuyen-nganh',
        permissions: [PERMISSIONS.BAOCAOTHONGKE]
      },
      {
        label: 'Tổng hợp kết quả thực hiện kết luận thanh tra theo kết luận',
        path: [ROUTES.BAO_CAO_CHI_TIET_KET_QUA_THUC_HIEN_KLTT],
        key: 'bao-cao-chi-tiet-ket-qua-thuc-hien-KLTT',
        permissions: [PERMISSIONS.BAOCAOTHONGKE]
      },
      {
        label: 'Tổng hợp kết quả thực hiện kiến nghị về tài chính trong KLKN của Kiểm toán Nhà nước',
        path: [ROUTES.BAO_CAO_TONG_HOP_KET_QUA_THUC_HIEN_KIEN_NGHI],
        key: 'bao-cao-tong-hop-ket-qua-thuc-hien-kien-nghi',
        permissions: [PERMISSIONS.BAOCAOTHONGKE]
      },
      {
        label: 'Tổng hợp các kiến nghị về cơ chế chính sách trong KLKN của Kiểm toán Nhà nước đã thực hiện',
        path: [ROUTES.BAO_CAO_TONG_HOP_CAC_KIEN_NGHI_VE_CO_CHE_CHINH_SACH_DA_THUC_HIEN],
        key: 'bao-cao-tong-hop-cac-kien-nghi-ve-co-che-chinh-sach-da-thuc-hien',
        permissions: [PERMISSIONS.BAOCAOTHONGKE]
      },
      {
        label: 'Tổng hợp các kiến nghị chấn chỉnh, rút kinh nghiệm trong KLKN của Kiểm toán Nhà nước đã thực hiện',
        path: [ROUTES.BAO_CAO_TONG_HOP_KIEN_NGHI_CHAN_CHINH_RUT_KINH_NGHIEM],
        key: 'bao-cao-tong-hop-kien-nghi-chan-chinh-rut-kinh-nghiem',
        permissions: [PERMISSIONS.BAOCAOTHONGKE]
      },
      {
        label: 'Tổng hợp các kiến nghị về kiểm điểm, trách nhiệm tập thể, cá nhân trong KL Kiểm toán đã thực hiện',
        path: [ROUTES.BAO_CAO_TONG_HOP_KIEN_NGHI_KIEM_DIEM_TRACH_NHIEM_TAP_THE_CA_NHAN],
        key: 'bao-cao-tong-hop-kien-nghi-kiem-diem-trach-nhiem-tap-the-ca-nhan',
        permissions: [PERMISSIONS.BAOCAOTHONGKE]
      },
      {
        label: 'Tổng hợp các kết quả kiểm điểm trách nhiệm cán bộ, công chức, viên chức theo các kết luận thanh tra',
        path: [ROUTES.BAO_CAO_TONG_HOP_KIEN_NGHI_KIEM_DIEM_TRACH_NHIEM_CAN_BO_CONG_CHUC_VIEN_CHUC],
        key: 'tong-hop-kien-nghi-kiem-diem-trach-nhiem-can-bo-cong-chuc-vien-chuc',
        permissions: [PERMISSIONS.BAOCAOTHONGKE]
      },
      {
        label: 'Tổng hợp các kết quả thực hiện kiến nghị tài chính',
        path: [ROUTES.BAO_CAO_TONG_HOP_KET_QUA_THUC_HIEN_KN_TAI_CHINH],
        key: 'tong-hop-ket-qua-thuc-hien-KN-tai-chinh',
        permissions: [PERMISSIONS.BAOCAOTHONGKE]
      }
    ]
  },

  {
    label: 'BCTK KL Thanh tra, Kiểm toán',
    key: 'bao-cao-thong-ke-kltt-ktnn',
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI],
    icon: 'report',
    children: [
      {
        label: 'BC thống kê kết luận thanh tra, kiến nghị kiểm toán',
        path: [ROUTES.BAO_CAO_TONG_HOP_KET_LUAN_THANH_TRA_KIEM_TOAN],
        key: 'bao-cao-tong-hop-ket-luan-thanh-tra-kiem-toan',
        permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
      },
      {
        label: 'Thanh tra-BC tổng hợp kết quả thực hiện kiến nghị xử lý sai phạm về kinh tế',
        path: [ROUTES.BAO_CAO_TONG_HOP_KET_QUA_THUC_HIEN_KIEN_NGHI_KTXH],
        key: 'bao-cao-tong-hop-ket-qua-thuc-hien-kien-nghi-ktxh',
        permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
      },
      {
        label: 'Thanh tra-BC kết quả thực hiện các nội dung kiến nghị thanh tra',
        path: [ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA],
        key: 'bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra',
        permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
      },
      {
        label: 'Thanh tra-BC tổng hợp kết quả rà soát các cuộc thanh tra về kinh tế - xã hội',
        path: [ROUTES.BAO_CAO_TONG_HOP_KET_QUA_RA_SOAT_CAC_CUOC_TT_VE_KTXH],
        key: 'bao-cao-tong-hop-ket-qua-ra-soat-cac-cuoc-tt-ve-ktxh',
        permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
      },
      {
        label: 'Thanh tra-BC chi tiết các vụ việc, đối tượng chuyển cơ quan điều tra',
        path: [ROUTES.BAO_CAO_CHI_TIET_CAC_VU_VIEC_DOI_TUONG_CHUYEN_CO_QUAN_DIEU_TRA],
        key: 'bao-cao-chi-tiet-cac-vu-viec-doi-tuong-chuyen-co-quan-dieu-tra',
        permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
      },
      {
        label: 'Thanh tra-BC chi tiết các vụ việc, đối tượng đề nghị chuyển cơ quan điều tra',
        path: [ROUTES.BAO_CAO_CHI_TIET_CAC_VU_VIEC_DOI_TUONG_DE_NGHI_CHUYEN_CQDT],
        key: 'bao-cao-chi-tiet-cac-vu-viec-doi-tuong-de-nghi-chuyen-cqdt',
        permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
      },
      {
        label: 'Kiểm toán-BC kết quả thực hiện kiến nghị xử lý tài chính và xử lý khác',
        path: [ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_KIEN_NGHI_XU_LY_TC_XU_LY_KHAC],
        key: 'bao-cao-ket-qua-thuc-hien-kien-nghi-xu-ly-tc-xu-ly-khac',
        permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
      },
      {
        label: 'Kiểm toán-BC kết quả thực hiện các nội dung kiến nghị kiểm toán',
        path: [ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_CAC_NOI_DUNG_KIEN_NGHI_KIEM_TOAN],
        key: 'bao-cao-ket-qua-thuc-hien-cac-noi-dung-kien-nghi-kiem-toan',
        permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
      },
      {
        label: 'Xuất Tờ trình - KL Thanh tra Chính phủ',
        path: [ROUTES.XUAT_TO_TRINH_KL77],
        key: 'xuat-to-trinh-kl77',
        permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
      }
    ]
  },
  // {
  //   label: 'BCTK KL Kiểm toán',
  //   key: 'bao-cao-thong-ke-klkt',
  //   permissions: [PERMISSIONS.BAOCAOTHONGKE],
  //   icon: 'statistical',
  //   children: []
  // },
  {
    label: 'QL báo cáo thống kê động',
    key: 'bao-cao-thong-ke-dong',
    icon: 'dynamic',
    path: [ROUTES.BAO_CAO_THONG_KE_DONG],
    permissions: [PERMISSIONS?.BAOCAOTHONGKEDONG]
  },
  {
    label: 'Quản trị hệ thống',
    key: 'quan-tri-he-thong',
    permissions: [PERMISSIONS.DANHMUC],
    icon: 'system',
    children: [
      // {
      //   label: 'Danh sách quản lý đơn vị theo dõi',
      //   path: [ROUTES.DON_VI_THEO_DOI],
      //   key: 'don-vi-theo-doi',
      // },
      // {
      //   label: 'Danh mục đơn vị',
      //   path: [`${ROUTES.DANH_MUC_DON_VI}/0`],
      //   key: 'danh-muc-don-vi',
      // },
      {
        label: 'QL nhóm đối tượng TT',
        path: [ROUTES.NHOM_DOI_TUONG_THANH_TRA],
        key: 'nhom-doi-tuong-thanh-tra',
        permissions: [PERMISSIONS.DM_NHOMDOITUONG_DANHSACH]
      },
      {
        label: 'QL đối tượng TT',
        path: [ROUTES.DOI_TUONG_THANH_TRA],
        key: 'quan-ly-doi-tuong-thanh-tra',
        permissions: [PERMISSIONS.DM_DOITUONGTHANHTRA_DANHSACH]
      },
      {
        label: 'Danh mục loại kết luận',
        path: [ROUTES.DANH_MUC_LOAI_KET_LUAN],
        key: 'danh-muc-loai-ket-luan',
        permissions: [PERMISSIONS.DM_LOAIKETLUAN_DANHSACH]
      },
      {
        label: 'Danh mục lĩnh vực vi phạm',
        path: [ROUTES.DANH_MUC_LOAI_LINH_VUC_VI_PHAM],
        key: 'loai-linh-vuc-vi-pham',
        permissions: [PERMISSIONS.DM_LINHVUCVIPHAM_DANHSACH]
      },
      {
        label: 'Danh mục loại chi phí',
        path: [ROUTES.DANH_MUC_LOAI_CHI_PHI],
        key: 'loai-chi-phi',
        permissions: [PERMISSIONS.DM_LOAICHIPHI_DANHSACH]
      },
      {
        label: 'Danh mục loại Kiểm toán',
        path: [ROUTES.DANH_MUC_LOAI_KIEM_TOAN],
        key: 'loai-kiem-toan',
        permissions: [PERMISSIONS.DM_LOAIKIEMTOAN_DANHSACH]
      },
      {
        label: 'Danh mục loại nguồn vốn',
        path: [ROUTES.DANH_MUC_LOAI_NGUON_VON],
        key: 'loai-nguon-von',
        permissions: [PERMISSIONS.DM_LOAINGUONVON_DANHSACH]
      },
      {
        label: 'Danh mục dự án',
        path: [ROUTES.DANH_MUC_DU_AN],
        key: 'danh-muc-du-an',
        permissions: [PERMISSIONS.DM_DUAN_DANHSACH]
      },
      {
        label: 'Danh mục hình thức xử lý',
        path: [ROUTES.DANH_MUC_HINH_THUC_XU_LY],
        key: 'danh-muc-hinh-thuc-xu-ly',
        permissions: [PERMISSIONS.DM_HINHTHUCXULY_DANHSACH]
      },
      {
        label: 'Danh mục hình thức kiến nghị',
        path: [ROUTES.DANH_MUC_HINH_THUC_KIEN_NGHI],
        key: 'danh-muc-hinh-thuc-kien-nghi',
        permissions: [PERMISSIONS.DM_HINHTHUCKIENNGHI_DANHSACH]
      },
      {
        label: 'Danh sách thông báo',
        path: [ROUTES.DANH_SACH_THONG_BAO],
        key: 'danh-sach-thong-bao',
        permissions: []
      },
      // {
      //   label: 'Quản lý danh mục kiến nghị tài chính ',
      //   path: [ROUTES.KIEN_NGHI_TAI_CHINH],
      //   key: 'kien-nghi-tai-chinh',
      // },
      // {
      //   label: 'Danh sách báo cáo Kiểm toán',
      //   path: [ROUTES.BAO_CAO_KIEM_TOAN],
      //   key: 'bao-cao-kiem-toan',
      // },
      // {
      //   label: 'Danh sách nhóm người dùng',
      //   path: [ROUTES.NHOM_NGUOI_DUNG],
      //   key: 'danh-sach-nhom-nguoi-dung',
      // },
      // {
      //   label: 'Danh mục vai trò',
      //   path: [ROUTES.DANH_MUC_VAI_TRO],
      //   key: 'danh-muc-vai-tro',
      // },
      // {
      //   label: 'Phân quyền vai trò',
      //   path: [ROUTES.PHAN_QUYEN_VAI_TRO],
      //   key: 'phan-quyen-vai-tro',
      // },
      // {
      //   label: 'Quản lý người dùng',
      //   path: [ROUTES.QUAN_LY_NGUOI_DUNG],
      //   key: 'quan-ly-nguoi-dung',
      // },
      // {
      //   label: 'Danh mục phòng ban',
      //   path: [`${ROUTES.DANH_MUC_PHONG_BAN}/0`],
      //   key: 'danh-muc-phong-ban',
      // },
      // {
      //   label: 'Danh mục chức vụ',
      //   path: [ROUTES.DANH_MUC_CHUC_VU],
      //   key: 'danh-muc-chuc-vu',
      // },
      {
        label: 'Sao lưu khôi phục dữ liệu',
        path: [ROUTES.SAO_LUU_DU_LIEU],
        key: 'sao-luu-du-lieu',
        permissions: [PERMISSIONS.SAOLUUBACKUP_XEM]
      }
    ]
  }
]

// ===== Phase 2: chèn mục menu mới theo key, không đổi thứ tự các mục cũ =====
const chenSau = (ds: MenuType[], key: string, ...items: MenuType[]) => {
  const viTri = ds.findIndex((item) => item.key === key)
  ds.splice(viTri < 0 ? ds.length : viTri + 1, 0, ...items)
}

const chenTruoc = (ds: MenuType[], key: string, ...items: MenuType[]) => {
  const viTri = ds.findIndex((item) => item.key === key)
  ds.splice(viTri < 0 ? ds.length : viTri, 0, ...items)
}

const nhomKiemToan = menuData.find((item) => item.key === 'qlklkn-kiem-toan-nn')
if (nhomKiemToan?.children) {
  chenSau(nhomKiemToan.children, 'ql-theo-doi-kien-nghi-ktnn', {
    label: 'Phúc tra, báo cáo Kiểm toán nhà nước',
    path: [ROUTES.KTNN_PHUC_TRA],
    key: 'ktnn-phuc-tra',
    permissions: [PERMISSIONS.KTNN_PHUCTRA]
  })
}

chenSau(
  menuData,
  'qlklkn-kiem-toan-nn',
  {
    label: 'Thu hồi tài sản vụ án hình sự',
    key: 'vu-an-hinh-su',
    icon: 'report',
    permissions: [PERMISSIONS.VUAN],
    children: [
      {
        label: 'Khởi tố vụ án',
        path: [ROUTES.VU_AN_KHOI_TO],
        key: 'vu-an-khoi-to',
        permissions: [PERMISSIONS.VUAN_KHOITO_CAPNHAT]
      },
      {
        label: 'Truy tố vụ án',
        path: [ROUTES.VU_AN_TRUY_TO],
        key: 'vu-an-truy-to',
        permissions: [PERMISSIONS.VUAN_TRUYTO_CAPNHAT]
      },
      {
        label: 'Xét xử sơ thẩm',
        path: [ROUTES.VU_AN_SO_THAM],
        key: 'vu-an-so-tham',
        permissions: [PERMISSIONS.VUAN_XETXU_CAPNHAT]
      },
      {
        label: 'Xét xử phúc thẩm',
        path: [ROUTES.VU_AN_PHUC_THAM],
        key: 'vu-an-phuc-tham',
        permissions: [PERMISSIONS.VUAN_XETXU_CAPNHAT]
      },
      {
        label: 'Quyết định thi hành án',
        path: [ROUTES.VU_AN_THI_HANH_AN],
        key: 'vu-an-thi-hanh-an',
        permissions: [PERMISSIONS.VUAN_THIHANHAN_CAPNHAT]
      },
      {
        label: 'Cập nhật tiến độ thu hồi',
        path: [ROUTES.VU_AN_TIEN_DO_THU_HOI],
        key: 'vu-an-tien-do-thu-hoi',
        permissions: [PERMISSIONS.VUAN_THEODOI_CAPNHAT]
      },
      {
        label: 'Vụ án do Trung ương ủy thác',
        path: [ROUTES.VU_AN_UY_THAC],
        key: 'vu-an-uy-thac',
        permissions: [PERMISSIONS.VUAN_UYTHAC_CAPNHAT]
      },
      {
        label: 'Theo dõi thực hiện chung',
        path: [ROUTES.VU_AN_THEO_DOI_CHUNG],
        key: 'vu-an-theo-doi-chung',
        permissions: [PERMISSIONS.VUAN]
      },
      {
        label: 'Báo cáo tổng quan thu hồi tài sản',
        path: [ROUTES.VU_AN_BAO_CAO_TONG_QUAN],
        key: 'vu-an-bao-cao-tong-quan',
        permissions: [PERMISSIONS.VUAN_BAOCAO]
      },
      {
        label: 'Báo cáo chi tiết thu hồi tài sản',
        path: [ROUTES.VU_AN_BAO_CAO_CHI_TIET],
        key: 'vu-an-bao-cao-chi-tiet',
        permissions: [PERMISSIONS.VUAN_BAOCAO]
      }
    ]
  },
  {
    label: 'Quản lý file tập trung',
    path: [ROUTES.QUAN_LY_FILE_TAP_TRUNG],
    key: 'quan-ly-file-tap-trung',
    icon: 'file',
    permissions: [PERMISSIONS.QLFILE_TAPTRUNG]
  }
)

const nhomQuanTri = menuData.find((item) => item.key === 'quan-tri-he-thong')
if (nhomQuanTri?.children) {
  chenTruoc(
    nhomQuanTri.children,
    'danh-sach-thong-bao',
    {
      label: 'Danh mục tội phạm',
      path: [ROUTES.DANH_MUC_TOI_PHAM],
      key: 'danh-muc-toi-pham',
      permissions: [PERMISSIONS.DANHMUC, PERMISSIONS.DM_TOIPHAM_DANHSACH]
    },
    {
      label: 'Danh mục loại thu hồi',
      path: [ROUTES.DANH_MUC_LOAI_THU_HOI],
      key: 'danh-muc-loai-thu-hoi',
      permissions: [PERMISSIONS.DANHMUC, PERMISSIONS.DM_LOAITHUHOI_DANHSACH]
    },
    {
      label: 'Danh mục loại tài sản thu hồi',
      path: [ROUTES.DANH_MUC_LOAI_TAI_SAN],
      key: 'danh-muc-loai-tai-san-thu-hoi',
      permissions: [PERMISSIONS.DANHMUC, PERMISSIONS.DM_LOAITAISAN_DANHSACH]
    },
    {
      label: 'Danh mục file',
      path: [ROUTES.DANH_MUC_FILE],
      key: 'danh-muc-file',
      permissions: [PERMISSIONS.DANHMUC, PERMISSIONS.DM_LOAIFILE_DANHSACH]
    }
  )
}
